/* Kay Galerie · Hero Licht (WebGL). One draw call per frame; sharp at screen resolution; pauses off screen; still frame for reduced motion.
   Sizes and pointer use the canvas box (on phones the canvas is only the top stage of the section). */
(function () {
function init(root) {
if (!root || root.dataset.kgReady) return;
root.dataset.kgReady = '1';
var cv = root.querySelector('canvas');
var btn = root.querySelector('.kg-licht__btn--solid');
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var gl = cv.getContext('webgl', { antialias: false, alpha: false, depth: false, stencil: false, preserveDrawingBuffer: false, powerPreference: 'high-performance' });
if (!gl) { root.classList.add('kg-licht--static'); wireButton(); return; }

var VS = 'attribute vec2 p; void main(){ gl_Position = vec4(p, 0.0, 1.0); }';
var FS = window.KG_LICHT_FS;
if (!FS) { root.classList.add('kg-licht--static'); wireButton(); return; }

function sh(type, src) {
var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s);
if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { console.error('kg-licht shader', gl.getShaderInfoLog(s)); return null; }
return s;
}
var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS);
if (!vs || !fs) { root.classList.add('kg-licht--static'); wireButton(); return; }
var prog = gl.createProgram(); gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { root.classList.add('kg-licht--static'); wireButton(); return; }
gl.useProgram(prog);
var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
var loc = gl.getAttribLocation(prog, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
var U = {}; ['uRes', 'uTime', 'uLight', 'uGlow', 'uRot', 'uPortrait'].forEach(function (n) { U[n] = gl.getUniformLocation(prog, n); });

var mx = 0.30, my = 0.32, tx = 0.30, ty = 0.32, on = false, glow = 0, lastMove = -1e9;
var visible = true, raf = 0, dirty = true, quality = 1, cssW = 0, cssH = 0, frames = 0, slow = 0, lastT = 0, t0 = performance.now();

function size() {
var r = cv.getBoundingClientRect();
if (r.width < 2 || r.height < 2) return false;
cssW = r.width; cssH = r.height;
var dpr = Math.max(window.devicePixelRatio || 1, 1.5) * quality;
while (cssW * cssH * dpr * dpr > 4.6e6) dpr *= 0.92;
var w = Math.round(cssW * dpr), h = Math.round(cssH * dpr);
if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
gl.viewport(0, 0, w, h);
dirty = true;
return true;
}

function draw(now) {
var t = (now - t0) / 1000;
gl.uniform2f(U.uRes, cv.width, cv.height);
gl.uniform1f(U.uTime, t);
gl.uniform2f(U.uLight, mx, my);
gl.uniform1f(U.uGlow, glow);
gl.uniform1f(U.uRot, reduce ? 0.25 : 0.25 + 0.55 * Math.sin(t * 0.11));
gl.uniform1f(U.uPortrait, cssW / cssH < 0.9 ? 1 : 0);
gl.drawArrays(gl.TRIANGLES, 0, 3);
}

function tick(now) {
raf = 0;
if (!visible || !cssW) return;
if (!reduce && now - lastMove > 2600) {
tx = 0.5 + 0.32 * Math.cos(now * 0.00021);
ty = 0.30 + 0.16 * Math.sin(now * 0.00029);
}
var k = reduce ? 1 : 0.06;
mx += (tx - mx) * k; my += (ty - my) * k;
glow += ((on ? 1 : 0) - glow) * (reduce ? 1 : 0.04);
draw(now);
if (lastT && !reduce) {
var dt = now - lastT; frames++;
if (dt > 26) slow++;
if (frames >= 40) { if (slow > 24 && quality > 0.5) { quality *= 0.82; size(); } frames = 0; slow = 0; }
}
lastT = now;
if (!reduce) raf = requestAnimationFrame(tick);
}
function kick() { if (!raf && visible) raf = requestAnimationFrame(tick); }

function point(cx, cy) {
var r = cv.getBoundingClientRect();
tx = Math.min(1, Math.max(0, (cx - r.left) / r.width)); ty = Math.min(1, Math.max(0, (cy - r.top) / r.height));
lastMove = performance.now(); kick();
}
root.addEventListener('pointermove', function (ev) { point(ev.clientX, ev.clientY); });
root.addEventListener('touchmove', function (ev) { var t = ev.touches[0]; if (t) point(t.clientX, t.clientY); }, { passive: true });
function wireButton() {
btn.addEventListener('click', function () {
on = !on;
btn.setAttribute('aria-pressed', on ? 'true' : 'false');
btn.textContent = on ? btn.dataset.off : btn.dataset.on;
root.classList.toggle('kg-licht--on', on);
kick();
});
}
wireButton();
if ('IntersectionObserver' in window) {
new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) { lastT = 0; kick(); } }).observe(root);
}
var rt;
function relayout() { clearTimeout(rt); rt = setTimeout(function () { if (size()) kick(); }, 120); }
if ('ResizeObserver' in window) { var ro = new ResizeObserver(relayout); ro.observe(root); ro.observe(cv); } else window.addEventListener('resize', relayout);
if (size()) kick();
}
function boot() { var list = document.querySelectorAll('.kg-licht'); for (var i = 0; i < list.length; i++) init(list[i]); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();